module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rUS4bW/cover.jpeg?1685327318683",
      "alt": "This image is the cover for the book Asura Continent, Volume 1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Asura Continent, Volume 1\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When Lu Yang returned to the world that he lived in for many years, he unexpectedly discovered that the time was fixed at three days before he disappeared. Back then, Lu Yang had tried to learn literature but failed to do so. He could only be mocked by his clansmen as trash if he had no cultivation. He was helpless to do anything about it. In the past, his mother had been neglected because of her birth, so she had to wash her face with tears all day long. Back then, he had suffered all sorts of humiliation and vowed to become stronger. However, under the manipulation of fate, there was nothing he could do about it. Now that he had returned from the Asura Realm, Lu Yang wanted to change everything. He wanted to make heaven and earth submit to him.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ban MuFangTang, Babel Novel\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Funstory\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0